export const filters = {
    default : 'default',
    inflatedFilter : 'red',
    deflatedFilter: 'orange',
    OoSFilter: 'deepRed'
}